
import React from 'react';
import { Button } from '@/components/ui/button';
import { Star, ThumbsUp, Settings } from 'lucide-react';
import { UserProfile } from '@/types';

interface UpgradePromoProps {
  profiles: UserProfile[];
}

const UpgradePromo: React.FC<UpgradePromoProps> = ({ profiles }) => {
  return (
    <div className="mt-8 bg-muted/30 rounded-lg p-6">
      <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-6 items-center">
        <div>
          <h3 className="text-xl font-medium mb-2 flex items-center gap-2">
            <Star className="h-5 w-5 text-yellow-500" />
            Upgrade to Pro Matching
          </h3>
          <p className="text-muted-foreground mb-4">
            Get unlimited matches, advanced filters, and priority visibility to find your ideal collaborators faster.
          </p>
          <div className="flex flex-wrap gap-3">
            <Button className="gap-2">
              <ThumbsUp className="h-4 w-4" />
              <span>Upgrade Now</span>
            </Button>
            <Button variant="outline" className="gap-2">
              <Settings className="h-4 w-4" />
              <span>Match Settings</span>
            </Button>
          </div>
        </div>
        <div className="w-full md:w-auto flex md:flex-col items-center gap-4">
          <div className="flex -space-x-4">
            {profiles.slice(1, 4).map(profile => (
              <img 
                key={profile.userId}
                src={profile.avatarUrl} 
                alt={profile.name} 
                className="w-10 h-10 rounded-full border-2 border-background"
              />
            ))}
          </div>
          <div className="text-sm text-muted-foreground">
            <strong>50+</strong> new musicians in your area
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpgradePromo;
